import nanoid from 'nanoid';
import { gql, insertGraphQLFragments } from '../GraphQLClient';
import { serializeUserBasic, fragmentUserBasic } from './serializeUser';
import { defaultsTo } from '../../utils/utilsGlobal';


export const fragmentCalendar = insertGraphQLFragments(gql`
  fragment fragmentCalendar on ScheduleCalendarEntry {
    ...on WorkCalendarHeatMap {
      workingCount
      employees {
        ...fragmentUserBasic
      }
    }
    ...on WorkCalendarDay {
      breaks {
        beginTimestamp
        endTimestamp
      }
    }
    beginTimestamp
    endTimestamp
  }
`, { fragmentUserBasic });


export const fragmentSchedule = gql`
  fragment fragmentShedule on Schedule {
    id
    ... on WeeklySchedule {
      __typename
      endDate
      weekDay
      beginTime
      endTime
      endNextDay
      breaks {
        beginTime
        endTime
        startNextDay
        endNextDay
      }
    }
  }
`;


export function serializeCalendar(data) {
  const { breaks, employees, workingCount } = data || {};
  return {
    ...defaultsTo(data, {
      beginTimestamp: '',
      endTimestamp: '',
    }),
    breaks: (breaks || []).map(breakItem => {
      return defaultsTo(breakItem, {
        beginTimestamp: '',
        endTimestamp: '',
      });
    }),
    operators: (employees || []).map(serializeUserBasic),
    workingOperatorsCount: workingCount || 0,
  };
}


export function serializeWeekSchedule(data) {
  const DAYS_DICT = [
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY',
  ];

  const scheduleByDay = {};
  (data || []).forEach(item => {
    scheduleByDay[item.weekDay] = item;
  });

  const processTime = (timeString) => {
    return typeof timeString === 'string' ? timeString.split(':').slice(0, 2).join(':') : '';
  };

  return DAYS_DICT.map(dayName => {
    const { id, beginTime, endTime, endNextDay, breaks } = scheduleByDay[dayName] || {};
    const hasDaySchedule = Boolean(scheduleByDay[dayName]);
    return {
      id: id || nanoid(),
      type: hasDaySchedule ? 'working' : 'timeOff',
      weekDay: dayName,
      beginTime: processTime(beginTime),
      endTime: processTime(endTime),
      endNextDay: endNextDay || false,
      breaks: (breaks || []).map(breakItem => {
        const { beginTime, endTime, endNextDay, startNextDay } = breakItem || {};
        return {
          id: nanoid(),
          beginTime: processTime(beginTime),
          endTime: processTime(endTime),
          startNextDay: startNextDay || false,
          endNextDay: endNextDay || false,
        };
      })
    };
  });
}


export function serializeWorkHours(data) {
  const toDateRange = ({ beginTimestamp, endTimestamp }) => {
    return {
      from: new Date(beginTimestamp),
      to: new Date(endTimestamp),
    };
  };
  const sortByDate = (a,b) => {
    return +a.from < +b.from ? -1 : 1;
  };
  return (data || [])
    .map(day => {
      const { from, to } = toDateRange(day);
      const breaks = (day.breaks || []).map(toDateRange).sort(sortByDate);
      return { from, to, breaks };
    })
    .sort(sortByDate);
}
